import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { BulkWhatsappMessage, FreeWhatsappReceivers } from './whatsapp.interface';
export class WhatsappService {
   async getWhatsapps() {
      throw Error('Method not implemented');
   }

   async getWhatsappTemplates() {
      const response = await http.get('communications/whatsapp/templates', { ...cacheFirstConfig });
      return response.data;
   }

   async postWhatsapp() {
      throw Error('Method not implemented');
   }

   async putWhatsapp() {
      throw Error('Method not implemented');
   }

   async deleteWhatsapp() {
      throw Error('Method not implemented');
   }
   async CheckFreeWhatsappReceivers(freeWhatsappReceivers: FreeWhatsappReceivers) {
      const response = await http.post('communications/whatsapp/check-allowed-bulk', freeWhatsappReceivers);
      return response.data;
   }
   async sendBulk(candidateBulkSms: BulkWhatsappMessage) {
      const formData = new FormData();
      if (candidateBulkSms.original_recipient) {
         formData.append('original_recipient', candidateBulkSms.original_recipient);
      } else {
         formData.append('receiver_type', candidateBulkSms.receiver_type);
         candidateBulkSms.receiver_ids?.forEach((id) => {
            formData.append('receiver_ids[]', id.toString());
         });
      }
      formData.append('message', candidateBulkSms.message || '');
      if (candidateBulkSms.template_id) formData.append('template_id', candidateBulkSms.template_id?.toString());
      if (candidateBulkSms.position_id) formData.append('position_id', candidateBulkSms.position_id?.toString());
      if (candidateBulkSms.customer_id) formData.append('customer_id', candidateBulkSms.customer_id?.toString());
      if (candidateBulkSms.attachments) formData.append('attachment', candidateBulkSms.attachments);
      if (candidateBulkSms.journey_id) formData.append('journey_id', candidateBulkSms.journey_id?.toString());
      if (candidateBulkSms.journey_team_id) formData.append('journey_team_id', candidateBulkSms.journey_team_id?.toString());
      if (candidateBulkSms.variables) {
         Object.keys(candidateBulkSms.variables).forEach((key) => {
            formData.append(`variables[${key}]`, candidateBulkSms.variables?.[key] || '');
         });
      }
      formData.append('batch', candidateBulkSms.batch.toString());
      const response = await http.post('communications/whatsapp/send', formData);
      return response.data;
   }
}
